import { render, staticRenderFns } from "./value-summary.vue?vue&type=template&id=ba635b9e&scoped=true"
import script from "./value-summary.vue?vue&type=script&lang=js"
export * from "./value-summary.vue?vue&type=script&lang=js"
import style0 from "./value-summary.vue?vue&type=style&index=0&id=ba635b9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba635b9e",
  null
  
)

export default component.exports